import { faker } from "@faker-js/faker";

const tagList = [];
for (let i = 0; i < 50; i++)
  tagList.push("#" + faker.commerce.productAdjective());

function createRandom(id) {
  return {
    id: id,
    name: faker.commerce.productName(),
    author: faker.name.fullName(),
    score: faker.datatype.number({ min: 0, max: 5, precision: 0.5 }),
    CP: faker.commerce.department(),
    wordCount: faker.datatype.number(),
    category: faker.commerce.product(),
    tags: faker.helpers.arrayElements(tagList).join(" "),
    content: faker.commerce.productDescription(),
    incomplete: faker.datatype.boolean(),
    updateDate: faker.date.past().toLocaleDateString("en-US"),
  };
}

function createRandomList(num) {
  const fake = [];

  for (let i = 0; i < num; i++) {
    fake.push(createRandom(i));
  }

  return fake;
}

export const fakeData = createRandomList(103);
